<template>
    <div class="main">
        <img class="brand-img" :src="item.url" v-for="item,index in brandList" :key="index" @click="toBrandDetail(item.type)"
            alt="">
    </div>
</template>

<script>

export default {
    name: 'brandList',

    data() {
        return {
            brandList: [
                {
                    url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/brand-introduce.png',
                    type: 1
                },
                {
                    url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/brand-history.png',
                    type: 2
                },
                {
                    url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/brand-honor.png',
                    type: 3
                },
                {
                    url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/brand-service.png',
                    type: 4
                },
                // {
                //     url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/environment.png',
                //     type: 5
                // },
                {
                    url: 'https://staticwecom.beautyfarm.com.cn/wecom-workbench/warehouse/brand-culture.png',
                    type: 6
                },
            ]
        }
    },
    mounted() {
        this.url = this.$route.query.url
    },
    methods: {
        toBrandDetail(type) {
            this.$router.push({ name: "brandDetail", query: { type } });
        }
    }
}
</script>

<style scoped>
.main {
    height: 100%;
    width: 750px;
    background: #f5f6f7;
    padding: 50px 30px;
}
.brand-img {
    width: 690px;
    height: 180px;
    margin-bottom: 20px;
}
</style>